import { Box, Typography } from '@mui/material';
import { Selector } from 'components/Form/Selectors/Selector';
import { ThemePalette } from 'mui.theme';
import { useAppSelector } from 'store/hook';
import { type Asset } from 'types/asset.types';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const SensorAssignmentHeader = ({
  enableDarkTheme,
  makeModels,
  selectedMakeModel,
  setSelectedMakeModel,
  assetBumperIds,
  selectedAsset,
  setSelectedAsset,
  updatedByName,
  updatedAt,
}: {
  enableDarkTheme: boolean;
  makeModels: string[];
  selectedMakeModel: string;
  setSelectedMakeModel: any;
  assetBumperIds: string[];
  selectedAsset: Asset;
  setSelectedAsset: any;
  updatedByName?: string | null;
  updatedAt?: string | null;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const makeModelList = makeModels.map((item) => {
    return {
      id: item,
      display: item,
    };
  });

  const assetList = assetBumperIds.map((item) => {
    return {
      id: item,
      display: item,
    };
  });

  return (
    <>
      {/* Make Model */}
      <Box
        sx={{
          paddingTop: '10px',
          paddingLeft: '10px',
          paddingRight: '10px',
        }}
      >
        <Typography
          variant="bodyBold"
          display="block"
          mb={'4px'}
          sx={{
            paddingBottom: '10px',
            color: palette.textPrimary,
          }}
        >
          {t('make_model')}
        </Typography>
        <Selector
          minWidth="200px"
          value={selectedMakeModel}
          onChange={(event) => {
            setSelectedMakeModel(String(event.target.value));
          }}
          selectorOptions={makeModelList}
          enableDarkTheme={enableDarkTheme}
        />
      </Box>
      {/* Bumper ID */}
      <Box
        sx={{
          paddingTop: '10px',
          paddingRight: '10px',
        }}
      >
        <Typography
          variant="bodyBold"
          display="block"
          mb={'4px'}
          sx={{
            paddingBottom: '10px',
            color: palette.textPrimary,
          }}
        >
          {t('bumper_id_11')}
        </Typography>
        <Selector
          minWidth="200px"
          value={selectedAsset.bumperNumber}
          onChange={(event) => {
            setSelectedAsset(String(event.target.value));
          }}
          selectorOptions={assetList}
          enableDarkTheme={enableDarkTheme}
        />
      </Box>
      {/* Updated By */}
      <Box
        sx={{
          paddingTop: '35px',
          paddingRight: '10px',
          marginLeft: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            color: enableDarkTheme ? '#aaaaaa' : '#666666',
            fontSize: '0.70rem',
            lineHeight: 1.5,
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'minmax(90px, auto) 1fr',
              gap: '0 8px',
              rowGap: '2px',
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'right',
                fontWeight: 600,
                color: enableDarkTheme ? '#ffffff' : '#000000',
              }}
            >
              {t('last_updated')}
            </Typography>
            <Typography
              variant="caption"
              sx={{ textAlign: 'left', color: 'inherit' }}
            >
              {updatedAt ? new Date(updatedAt).toLocaleDateString() : 'N/A'}
            </Typography>

            <Typography
              variant="caption"
              sx={{
                textAlign: 'right',
                fontWeight: 600,
                color: enableDarkTheme ? '#ffffff' : '#000000',
              }}
            >
              {t('updated_by')}
            </Typography>
            <Typography
              variant="caption"
              sx={{ textAlign: 'left', color: 'inherit' }}
            >
              {updatedByName ?? 'System'}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};
